<template>
  <div>
    <div class="col-12">
      <div
        class="row col-12 items-center justify-between text-brand-5 text-weight-bold q-mb-lg q-ml-md container-input-search"
      ></div>
      <q-table
        :columns="columns"
        :rows="listaProdutos"
        color="primary"
        row-key="id"
        dense
        table-header-class="bg-accent text-weight-bold"
        hide-pagination
        class="tabela-tamanho-fixo"
        hide-bottom
        v-model:pagination="pagination"
        :loading="loading"
        @request="paginarTabela"
        :grid="$q.screen.lt.sm"
        flat
      >
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Produtos com CA</span
          >
        </template>
        <template v-slot:top-right>
          <div class="row col-12 justify-center">
            <q-btn
              icon="link"
              color="secondary"
              dense
              label="Vincular CAs"
              class="q-mr-sm"
              no-caps
              @click="$emit('abrir-modal-vinculo')"
            />
          </div>
          <q-input
            rounded
            outlined
            dense
            debounce="300"
            v-model="busca"
            type="text"
            class="col-md-3 col-xs"
            placeholder="Pesquisar"
          >
            <template v-slot:append>
              <q-icon name="search" />
            </template>
          </q-input>
        </template>
        <template v-slot:item="props">
          <div class="col-xs-12 col-sm-6 col-md-4 q-mb-md">
            <div class="row card text-grid-table text-brand-5">
              <div
                class="row col-12 text-grid-table items-center q-mb-xs justify-between q-px-sm q-pt-sm"
              >
                <div><strong>ID: </strong>{{ props.row.id }}</div>
                <div><strong>Código: </strong>{{ props.row.code }}</div>
                <div>
                  <strong>CA Atual: </strong
                  >{{ props.row.pivot?.ca?.code || "Não associado" }}
                </div>
              </div>
              <div class="col-12 q-mb-xs q-px-sm">
                <strong>Nome: </strong
                >{{
                  props.row.pivot?.contract_product_description ||
                  props.row.name
                }}
              </div>
              <span class="row col-12 items-center q-mb-xs q-px-sm">
                <strong>Status: </strong>
                <div v-if="props.row.pivot.ca">
                  <div
                    v-if="props.row.pivot.ca?.status == 'Válido'"
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 5px"
                  >
                    <span class="elipse q-mr-sm bg-positive" />
                    <div style="width: fit-content" class="text-brand-5">
                      {{ props.row.pivot.ca?.status }}
                    </div>
                  </div>
                  <div
                    v-else
                    class="row align items-center"
                    style="width: fit-content; padding: 2px 2px"
                  >
                    <span class="elipse q-mr-sm bg-red" />
                    <div style="width: fit-content">
                      {{ props.row.pivot.ca?.status }}
                    </div>
                  </div>
                </div>
              </span>
              <div
                class="q-px-sm q-mb-sm"
                v-if="props.row.pivot?.ca?.expires_in"
              >
                <q-icon name="event" class="q-mr-xs" />
                <strong>Vencimento: </strong>
                <span>{{
                  props.row.pivot.ca.expires_in
                    .split(" ")[0]
                    .split("-")
                    .reverse()
                    .join("/")
                }}</span>
              </div>
              <div class="col-12">
                <div class="row">
                  <div
                    class="column col-4 btn-grid-esquerdo"
                    style="background: #58afc1"
                  ></div>
                  <div class="column col-4" v-if="props.row.pivot?.ca?.code">
                    <q-btn
                      stack
                      flat
                      color="primary"
                      no-caps
                      icon="verified"
                      class="btn-grid-meio"
                      style="height: 100%; background: #1976d2"
                      @click="
                        validateCaNumber(
                          props.row.pivot.ca?.code,
                          props.row.pivot.ca?.id
                        )
                      "
                    >
                      <span style="color: white; font-size: 10px">Validar</span>
                    </q-btn>
                  </div>
                  <div class="column col-4" v-else>
                    <div
                      class="btn-grid-meio"
                      style="
                        height: 100%;
                        background: #e0e0e0;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                      "
                    >
                      <span style="color: #666; font-size: 10px">Sem CA</span>
                    </div>
                  </div>
                  <div class="column col-4">
                    <q-btn
                      stack
                      flat
                      color="negative"
                      no-caps
                      icon="remove_circle_outline"
                      class="btn-grid-direito"
                      style="height: 100%"
                      @click="desassociarCa(props.row.id)"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-slot:header="props">
          <q-tr :props="props">
            <q-th
              class="text-weight-bolder"
              v-for="col in props.cols"
              :key="col.name"
              :props="props"
            >
              {{ col.label }}
            </q-th>
          </q-tr>
        </template>
        <template v-slot:body="props">
          <q-tr
            :style="props.selected ? 'background: #EFF5F5' : ''"
            class="text-brand-5 text-weight-bold"
          >
            <q-td>
              <span>{{ props.row.id }}</span>
            </q-td>
            <q-td class="cell-wrap">
              <span>{{ props.row.code }}</span>
            </q-td>
            <q-td class="cell-wrap descricao-produto">
              <span>{{
                props.row.pivot?.contract_product_description || props.row.name
              }}</span>
            </q-td>
            <q-td>
              <div v-if="props.row.pivot.ca">
                <div
                  v-if="props.row.pivot.ca?.status == 'Válido'"
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #e8ffec;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-positive" />
                  <div
                    style="width: fit-content"
                    class="text-bold text-brand-5"
                  >
                    {{ props.row.pivot.ca?.status }}
                  </div>
                </div>
                <div
                  v-else
                  class="row align items-center"
                  style="
                    width: fit-content;
                    background: #ffe9e9;
                    padding: 2px 5px;
                  "
                >
                  <span class="elipse q-mr-sm bg-red" />
                  <div
                    style="width: fit-content; color: #850202"
                    class="text-bold"
                  >
                    {{ props.row.pivot.ca?.status }}
                  </div>
                </div>
              </div>
            </q-td>
            <q-td>
              <span v-if="props.row.pivot?.ca?.expires_in">{{
                props.row.pivot.ca.expires_in
                  .split(" ")[0]
                  .split("-")
                  .reverse()
                  .join("/")
              }}</span>
              <span v-else>-</span>
            </q-td>
            <q-td>
              <span>{{ props.row.pivot?.ca?.code || "Não associado" }}</span>
            </q-td>
            <q-td>
              <q-btn
                v-if="props.row.pivot?.ca?.code"
                style="padding: 0px 0px 0px 0px"
                color="primary"
                icon="verified"
                flat
                no-caps
                push
                @click="
                  validateCaNumber(
                    props.row.pivot.ca?.code,
                    props.row.pivot.ca?.id
                  )
                "
              >
              </q-btn>
              <span v-else class="text-grey-5">-</span>
            </q-td>
            <q-td>
              <q-btn
                v-if="props.row.pivot?.ca?.code"
                style="padding: 0px 0px 0px 0px"
                color="negative"
                icon="delete"
                flat
                no-caps
                push
                @click="desassociarCa(props.row.id)"
              >
              </q-btn>
              <span v-else class="text-grey-5">-</span>
            </q-td>
          </q-tr>
        </template>
      </q-table>
      <div class="row justify-start q-mt-md">
        <q-pagination
          :disable="disable"
          v-model="pagination.page"
          color="brand-5"
          active-color="secondary"
          active-text-color="white"
          :max="pagesNumber"
          :max-pages="5"
          :boundary-numbers="false"
          :direction-links="true"
          size="sm"
        />
      </div>
    </div>

    <!-- Modal de Validação de CA -->
    <CaValidationModal
      v-model="isModalOpen"
      :ca-number="currentCaNumber"
      :ca-id="currentCaId"
      @update:model-value="closeValidationModal"
      @ca-updated="handleCaUpdated"
    />
  </div>
</template>

<script>
import { ref, watch, computed, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import CaValidationModal from "../../../components/CaValidationModal.vue";
import { useCaValidation } from "../../../composables/useCaValidation";

const columns = [
  {
    name: "id",
    label: "ID",
    align: "left",
  },
  {
    name: "codigo",
    label: "Código",
    align: "left",
  },
  {
    name: "nome",
    label: "Nome do Produto",
    align: "left",
  },
  {
    name: "status",
    label: "Status",
    align: "left",
  },
  {
    name: "vencimento",
    label: "Vencimento",
    align: "left",
  },
  {
    name: "caativo",
    label: "CA Ativo",
    align: "left",
  },
  {
    name: "validar",
    label: "Validar CA",
    align: "left",
  },
  {
    name: "remover",
    label: "Remover CA",
    align: "left",
  },
];
export default {
  components: {
    CaValidationModal,
  },
  props: {
    ca: Object,
    status: String,
    caBusca: String,
    atualizarTabela: Number,
  },
  emits: ["limpar"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const {
      isModalOpen,
      currentCaNumber,
      currentCaId,
      openValidationModal,
      closeValidationModal,
      onCaUpdated,
    } = useCaValidation();

    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 15,
      rowsNumber: 15,
    });
    let recebeUnidade = ref({
      unidade: store.state.org.unidadeData.nome,
      id: store.state.org.unidadeData.id,
    });
    const listaProdutos = ref();
    const selecionados = ref([]);
    let loading = ref(false);
    let disable = ref(false);
    const busca = ref("");

    const listarProdutos = async (page = 1, rowsPerPage = 15) => {
      if (store.state.org.contract == undefined) {
        return;
      }
      disable.value = true;
      loading.value = true;
      try {
        let response = await store.dispatch("produtos/listarProdutos", {
          contract_id: store.state.org.contract,
          per_page: rowsPerPage,
          page: page,
          search: busca.value,
          ca_status: props.status?.value, // Filtro de status
          ca_code: props.caBusca, // Filtro de código do CA
        });
        listaProdutos.value = response.data.model.products.data;

        pagination.value.rowsPerPage = response.data.model.products.per_page;
        pagination.value.page = response.data.model.products.current_page;
        pagination.value.rowsNumber = response.data.model.products.total;
        loading.value = false;
        disable.value = false;
      } catch (error) {
        console.log(error);
      }
    };

    const paginarTabela = async () => {
      listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
    };

    const associarCas = async () => {
      if (selecionados.value.length == 0) {
        quasar.notify({
          message: "Selecione um produto pelo menos",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      if (props.ca == null) {
        quasar.notify({
          message: "Selecione um CA",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      const products = [];
      selecionados.value.forEach((produto) => {
        products.push({ product_id: produto, ca_id: props.ca.value });
      });
      try {
        await store.dispatch("produtos/associarCa", {
          catalog_id: recebeUnidade.value.id,
          products: products,
        });
        selecionados.value = [];
        busca.value = "";
        listarProdutos();
        emit("limpar");
        quasar.notify({
          message: "CAs vinculados com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao vincular CAs",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const desassociarCa = async (id) => {
      const products = [];
      products.push({ product_id: id, ca_id: null });
      try {
        await store.dispatch("produtos/associarCa", {
          catalog_id: recebeUnidade.value.id,
          products: products,
        });
        selecionados.value = [];
        listarProdutos();
        quasar.notify({
          message: "CAs desassociado com sucesso",
          color: "positive",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } catch (error) {
        console.log(error);
        quasar.notify({
          message: "Erro ao desassociar CAs",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const validateCaNumber = (caCode, caId = null) => {
      if (!caCode) {
        quasar.notify({
          message: "Número do CA não encontrado",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
        return;
      }
      openValidationModal(caCode, caId);
    };

    const handleCaUpdated = (updatedCa) => {
      // Recarrega a lista de produtos após atualização do CA
      listarProdutos();
      onCaUpdated(updatedCa);
    };

    watch(
      () => store.state.org.contract,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => pagination.value.page,
      () => {
        listarProdutos(pagination.value.page, pagination.value.rowsPerPage);
      }
    );

    watch(
      () => busca.value,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => props.status,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => props.atualizarTabela,
      () => {
        listarProdutos();
      }
    );

    watch(
      () => props.caBusca,
      () => {
        listarProdutos();
      }
    );

    onMounted(listarProdutos);

    return {
      columns,
      listarProdutos,
      pagination,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      listaProdutos,
      loading,
      disable,
      busca,
      paginarTabela,
      selecionados,
      associarCas,
      desassociarCa,
      validateCaNumber,
      handleCaUpdated,
      isModalOpen,
      currentCaNumber,
      currentCaId,
      closeValidationModal,
    };
  },
};
</script>

<style scoped>
.q-table__top,
thead tr:first-child th {
  background-color: #eef3fe;
}
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.mobile {
  display: none;
}
@media (max-width: 600px) {
  .titulo-tabela {
    display: none;
  }
  .container-input-search {
    margin: 40px 0px;
  }
  .text-grid-table {
    font-size: 13px;
  }
  .elipse {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    margin: 0px 4px 0px 0px;
  }
  .card {
    border: 1px solid #707070;
    border-radius: 5px;
  }
  .btn-grid-esquerdo {
    border-radius: 0px 0px 0px 5px;
    font-size: 12px;
  }
  .btn-grid-meio {
    border-radius: 0px;
    font-size: 12px;
  }
  .btn-grid-direito {
    border-radius: 0px 0px 5px 0px;
    font-size: 12px;
  }
  .btn {
    font-size: 13px;
    margin-bottom: 22px;
  }
  .btn-mobile {
    font-size: 12px;
  }
  .mobile {
    display: block;
  }
  .desktop {
    display: none;
  }
}
.cell-wrap {
  white-space: normal !important;
  word-wrap: break-word !important;
  word-break: break-word !important;
  overflow-wrap: break-word !important;
}
.descricao-produto {
  max-width: 400px;
}
</style>
